<template>
  <ul class="board">
    <li
      class="board-item"
      v-for="{ id, label, description } in items"
      :key="id"
    >
      <v-media class="board-media" :halfFilling="false" xAlign="c" yAlign="t">
        <template v-slot:left>
          <img
            :src="require(`@/assets/img/icons/check-circle-regular.svg`)"
            alt="#"
            class="board-img"
          />
        </template>

        <template v-slot:right>
          <div>
            <p class="board-label text-md">{{ label | capitalize }}</p>
            <p class="board-description text-t">{{ description }}</p>
          </div>
        </template>
      </v-media>

      <!-- <p class="board-label text-md">{{label | toLower | capitalize}}</p> -->
      <!-- <p class="board-description text-t">{{description}}</p> -->
    </li>
  </ul>
</template>

<script>
import VMedia from '@/components/ui/VMedia'

export default {
  name: 'VBoard',
  components: {
    VMedia,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
.board {
  width: 100%;
  column-count: 2;
  max-width: 900px;
  margin: 0 auto;

  &-img {
    width: 20px;
    padding: 5px 10px;
  }

  &-media {
  }

  &-item {
    text-align: left;
    box-sizing: border-box;
    padding: 15px 20px;
    line-height: 1.6;
    column-fill: balance;
    display: inline-block;
    width: 100%;
  }

  &-label {
    font-weight: 500;
    position: relative;
    color: #021759;
  }

  &-description {
    color: #3a3a3a;
  }
}
</style>

<style lang="scss" scoped>
@media (max-width: 500px) {
  .board {
    column-count: 1;
  }
}

@media (max-width: 375px), (max-width: 414px) {
  .board {
    &-item {
      line-height: 1.5;
      padding: 8px 20px;
    }
  }
}
</style>
